var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabIconWasteType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.368,
    height: 31.991,
    viewBox: "0 0 34.368 31.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MixedWaste",
    transform: "translate(0.1 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36854",
    "data-name": "Path 36854",
    d: "M7.431,22.86H4.786a.608.608,0,0,0,0,1.208H7.431a.608.608,0,0,0,0-1.208Z",
    transform: "translate(0.228 -2.111)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36855",
    "data-name": "Path 36855",
    d: "M27.461,22.86H24.816a.608.608,0,0,0,0,1.208h2.645a.608.608,0,0,0,0-1.208Z",
    transform: "translate(1.651 -2.111)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36856",
    "data-name": "Path 36856",
    d: "M17.351,22.86H14.706a.608.608,0,0,0,0,1.208h2.645a.608.608,0,0,0,0-1.208Z",
    transform: "translate(0.933 -2.111)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36857",
    "data-name": "Path 36857",
    d: "M34.172,22.1a2.005,2.005,0,0,0-.118-.229,7.435,7.435,0,0,0-2.4-2.415V11.393a.573.573,0,0,0-.536-.6H21.984a.586.586,0,0,0-.536.616v8.78a6.9,6.9,0,0,0-1.671-1.1L19.97,12l1.317-.99a.6.6,0,0,0,.236-.483V8.615h0V7.528h0a.578.578,0,0,0-.514-.616l-2.131-.121a.474.474,0,0,0-.386.169.588.588,0,0,0-.171.423v.5h-.878V7.347a.578.578,0,0,0-.514-.616l-2.206-.085a.57.57,0,0,0-.386.157.665.665,0,0,0-.171.423l-.086,3.043h0a.476.476,0,0,0,0,.169v.085a.493.493,0,0,0,.107.157h0l1.253,1.075-.182,6.908a5.252,5.252,0,0,0-.825.3l-4.016-12.9a.5.5,0,0,0-.278-.338.442.442,0,0,0-.407,0L1.548,9.05a.552.552,0,0,0-.3.3.716.716,0,0,0,0,.471l2.86,8.961A7.151,7.151,0,0,0,.177,21.948l-.1.157a.734.734,0,0,0,0,.266V36.863a.573.573,0,0,0,.536.6H33.7a.573.573,0,0,0,.536-.6V22.37a.531.531,0,0,0-.064-.266ZM30.584,12v6.932a6.521,6.521,0,0,0-7.861,2.717l-.236-.278V12ZM18.835,14.52v.616l-2.249-1.824V12.7Zm-2.292.229L18.771,16.6v.652L16.543,15.4Zm1.071,3.744-1.178-.978v-.652l2.142,1.8a7.027,7.027,0,0,0-.932-.145ZM16.329,7.89V8.4a.589.589,0,0,0,.525.628h1.96a.564.564,0,0,0,.386-.169.645.645,0,0,0,.171-.374V8.011h1.135v2.126l-1.317.99a.664.664,0,0,0-.236.483v1.425L15.161,9.992l.064-2.126ZM9.11,19.351A36.559,36.559,0,0,1,10.181,9.074l1.242,3.889a58.547,58.547,0,0,0-.4,8.055A7.071,7.071,0,0,0,9.11,19.351Zm3.031,1.51c0-1.715,0-3.623.139-5.326l1.3,4.07a7.056,7.056,0,0,0-1.435,1.256ZM6.571,13.844a2.329,2.329,0,0,1-2.72.676l-.364-1.208a1.631,1.631,0,0,0,1.446-.785,2.738,2.738,0,0,0-.814-3.249l.525-.217c1.778,1.485,2.624,3.623,1.928,4.782ZM3.208,10.016c.793.616,1.071,1.461.857,1.848a.9.9,0,0,1-.975.193L2.426,9.98l.418-.169A1.523,1.523,0,0,1,3.208,10.016Zm1.071,5.712a3.594,3.594,0,0,0,.61.06,2.839,2.839,0,0,0,2.6-1.268c.964-1.594.236-4.058-1.628-5.918l3.77-1.522v.193a33.721,33.721,0,0,0-1.6,11.594,6.159,6.159,0,0,0-2.089-.374,5.968,5.968,0,0,0-.8,0ZM33.2,36.259H1.066V22.54a5.756,5.756,0,0,1,4.852-2.848A5.756,5.756,0,0,1,10.77,22.54c.1.157.182.314.278.5a.536.536,0,0,0,.482.3A.515.515,0,0,0,11.991,23a4.8,4.8,0,0,1,.246-.459,5.8,5.8,0,0,1,4.534-2.851,5.625,5.625,0,0,1,4.784,2.271h0a5.958,5.958,0,0,1,.375.519l.118.205.171.314a.516.516,0,0,0,.471.3.524.524,0,0,0,.471-.338,3.2,3.2,0,0,1,.246-.459,5.551,5.551,0,0,1,9.639-.072h0Z",
    transform: "translate(-0.069 -5.679)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36858",
    "data-name": "Path 36858",
    d: "M13,26.72H10.356a.608.608,0,0,0,0,1.208H13a.573.573,0,0,0,.536-.6A.584.584,0,0,0,13,26.72Z",
    transform: "translate(0.624 -1.309)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36859",
    "data-name": "Path 36859",
    d: "M21.891,26.72H19.246a.584.584,0,0,0-.536.6.573.573,0,0,0,.536.6h2.645a.608.608,0,0,0,0-1.208Z",
    transform: "translate(1.256 -1.309)",
    fill: "#7bd2b4",
    stroke: "#7bd2b4",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconWasteType);
export default __webpack_public_path__ + "static/media/TabIcon_WasteType.a1f49e55a4b3c2b12f6b3f5b0f051d5b.svg";
export { ForwardRef as ReactComponent };